import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type OneClickLaunchModalType =
  | "None"
  | "RemoveAsins"
  | "PublishLaunchDates"
  | "PublishLaunchAttributesRemoveWeblab";

export interface OneClickLaunchModalState {
  message: string;
  isOpen: boolean;
  title: string;
  type: OneClickLaunchModalType;
}

export const oneClickLaunchModalInitialState: OneClickLaunchModalState = {
  message: "",
  isOpen: false,
  title: "",
  type: "None",
};

const oneClickLaunchModalState = createSlice({
  name: "oneClickLaunchModalState",
  initialState: oneClickLaunchModalInitialState,
  reducers: {
    setOneClickLaunchModalState(
      state: OneClickLaunchModalState,
      action: PayloadAction<OneClickLaunchModalState>
    ) {
      if (action.payload.isOpen) {
        state.isOpen = true;
        state.title = action.payload.title;
      } else {
        state = oneClickLaunchModalInitialState;
      }
    },
    showOclRemoveModal(state: OneClickLaunchModalState) {
      state.isOpen = true;
      state.message =
        'To remove the following ASINs from your Launch View, press "Remove". If you\'d like to remove them and reset their PSED and PSLD dates to 12/31/2037 GMT, press "Reset and Remove"';
      state.title = "Removing Launch ASIN(s)";
      state.type = "RemoveAsins";
    },
    showOclPublishLaunchDatesModal(state: OneClickLaunchModalState) {
      state.isOpen = true;
      state.message =
        "Do you want to publish today's date as the PSED and PSLD dates for these ASINs?";
      state.title = "Publish Launch Dates for ASIN(s)";
      state.type = "PublishLaunchDates";
    },
    showOclPublishLaunchAttributesRemoveWeblabModal(
      state: OneClickLaunchModalState
    ) {
      state.isOpen = true;
      state.message =
        "Do you want to publish launch attributes (third_party_site_excluded and index_suppressed) and remove the weblab gating for these ASINs?";
      state.title = "Publish Launch Attributes for ASIN(s)";
      state.type = "PublishLaunchAttributesRemoveWeblab";
    },
    clearOclModal(state: OneClickLaunchModalState) {
      state.isOpen = false;
      state.message = "";
      state.title = "";
      state.type = "None";
    },
  },
});

export const {
  showOclRemoveModal,
  clearOclModal,
  showOclPublishLaunchDatesModal,
  showOclPublishLaunchAttributesRemoveWeblabModal,
} = oneClickLaunchModalState.actions;

export default oneClickLaunchModalState.reducer;
